
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.47 29.59L5.9 23 45.16 1.72l4.42 8.14A4.62 4.62 0 1054 18l4.41 8.14-7.92 4.29","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"22.28","cy":"45.26","r":"2.05","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"30.38","cy":"38.82","r":"2.05","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M24.08 44.28l-5.11-9.43 8.1-6.44 5.11 9.44"}}),_c('path',{attrs:{"d":"M43.43 27a4.61 4.61 0 006.26 1.86L54.1 37 14.84 58.28l-4.42-8.15A4.62 4.62 0 006 42l-4.4-8.12L40.88 12.6l4.41 8.15A4.61 4.61 0 0043.43 27z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","stroke-dasharray":"2 2","d":"M31.54 18.81l12.88 24"}})])
          )
        }
      }
    